import React from 'react';
import NumberFormat from 'react-number-format';

export const CustomNumberFormat = ({ inputRef, onChange, ...props }) => {
  return (
    <NumberFormat
      {...props}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
    />
  );
};

export default CustomNumberFormat;
